import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDotCircle,
  faTimes,
  faUser,
  faUserCircle,
} from '@fortawesome/free-solid-svg-icons';

// Actions
import { gameActions, modalActions } from '../actions';

const PlayersManager = ({ roleLabels = [], disabled = false }) => {
  // State
  const [item, setItem] = useState({});

  // Redux
  const game = useSelector((state) => state.game);

  // Hooks
  const dispatch = useDispatch();

  // Effect: Component initialisation
  useEffect(() => {
    if (game?.data) {
      setItem(game.data);
    }
  }, [game?.data]);

  // Methods
  const handleGroupChange = (email, e) => {
    // console.log(email, e.target.value);

    const gindex = parseInt(e.target.value);

    // Update the player's group
    dispatch(
      gameActions.updateRegisteredPlayer({
        _id: item._id,
        email,
        gindex,
      })
    );
  };

  const removePlayerModal = (e, user) => {
    const username = `${user.name} ${user.lastname} ${user.email}`.trim();

    dispatch(
      modalActions.open({
        title: 'Remove Player',
        body: (
          <div>
            <p>
              Are you sure you want to remove <b>{username}</b> from this game?
            </p>
          </div>
        ),
        buttons: [
          <button
            key='btn-2'
            className='btn btn-outline-secondary'
            onClick={() => dispatch(modalActions.close())}>
            Cancel
          </button>,
          <button
            key='btn-1'
            className='btn btn-danger'
            onClick={() => {
              dispatch(gameActions.removeRegistered(item._id, [user?.email]));
              dispatch(modalActions.close());
            }}>
            Remove
          </button>,
        ],
      })
    );
  };

  const isOnline = (email) => {
    const online = game?.data?.online?.find((e) => e === email);
    return online ? true : false;
  };

  // Logic

  // Sort registered players by group
  const elements =
    item?.status === 'launched' ? item?.players : item?.registered;
  const registeredPlayers = elements
    ? [...elements].sort((a, b) => {
        if (a.gindex < b.gindex) return -1;
        if (a.gindex > b.gindex) return 1;
        return 0;
      })
    : [];

  // console.log({ game, item, registeredPlayers });

  return (
    <table className='table table-sm small table-hover table-striped mb-0'>
      <thead>
        <tr>
          <th scope='col text-center'>#</th>
          <th scope='col'>Email</th>
          <th scope='col'>Full Name</th>
          <th scope='col'>Access Link</th>
          <th scope='col'>Last Activity</th>
        </tr>
      </thead>
      <tbody>
        {registeredPlayers.map((rp, rpi) => {
          // Get the group labe

          // Get the player magic-link
          const ml =
            process.env.REACT_APP_GAME_URL +
            '?i=' +
            rp.game_id +
            '&e=' +
            rp.email +
            '&t=' +
            rp.token +
            '&k=1';

          return (
            <tr key={`tr-${rp.email}`}>
              <td className='text-center'>{rpi + 1}</td>
              <td>
                {rp.email}{' '}
                <button
                  className='btn btn-sm btn-link text-danger small ms-1 lh-1'
                  disabled={disabled}
                  onClick={(e) => removePlayerModal(e, rp)}>
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </td>

              <td>
                {rp?.name} {rp?.lastname}
              </td>

              <td>
                {/* Online Status */}
                <FontAwesomeIcon
                  icon={faUserCircle}
                  className={`text-${
                    isOnline(rp.email) ? 'success' : 'secondary'
                  } me-2`}
                  size='lg'
                />
                <a href={ml} target='_blank' rel='noreferrer'>
                  <code style={{ maxWidth: '100px' }}>Access Link</code>
                </a>
              </td>

              {/* Display last activity time in the locale short format */}
              <td>
                {rp.last_activity
                  ? new Date(rp.last_activity).toLocaleString('en-US', {
                      dateStyle: 'short',
                      timeStyle: 'short',
                    })
                  : '-'}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default PlayersManager;
